export default __webpack_public_path__ + "static/hero-pattern-dark-a35d414572b33421837b66e1b1633b15.svg";